<template>
    <div>
        <!-- 封禁表单 -->
        <el-form :model="platForm" status-icon :rules="rules" ref="platForm" label-width="100px">
            <el-form-item label="封禁时长" prop="time">
                <el-input type="text" v-model="platForm.time" placeholder="请输入封禁时长"></el-input>
            </el-form-item>
            <el-form-item label="时间类型" prop="unit">
                <el-select v-model="platForm.unit" placeholder="请选择">
                    <el-option label="分钟" :value="0"></el-option>
                    <el-option label="小时" :value="1"></el-option>
                    <el-option label="天" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="总禁言次数" prop="unit">
                <el-tag type="danger">{{ banCount }}</el-tag>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="submitForm('platForm')">提交</el-button>
                <el-button @click="resetForm('platForm')">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    props: {
        banCount: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            platForm: {
                time: '',
                unit: 0,
                userId: ''
            },
            rules: {
                time: [
                    { required: true, trigger: 'change', message: '请输入封禁时长' }
                ],
                unit: [
                    { required: true, trigger: 'change', message: '请选择时间类型' }
                ]
            }
        };
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (!this.platForm.time) {
                        this.$message.error('请输入禁言时长')
                        return false
                    }
                    if (this.platForm.unit == 0 && this.muteForm.time < 5) {
                        this.$message.error('禁言时长不能小于5分钟')
                        return false
                    }
                    this.$emit('platSubmit', this.platForm);
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
}
</script>

<style></style>